import * as React from "react"
import { Typography } from '@mui/material'


export default function customerColumn() {
  return {
    name: 'customer',
    label: 'Customer',
    options: {
      customBodyRender: (value) => (
        <Typography variant="subtitle1">{value ?? '-'}</Typography>
      ),
    },
  }
}
